import { IViewerFloor } from "../interfaces/IViewerFloor";

interface IViewerFloorsDictionary {
	[level: number]: Promise<IViewerFloor>;
}

export class ViewerFloorsDictionary implements IViewerFloorsDictionary {
	[level: number]: Promise<IViewerFloor>;

	public get listAsync(): Promise<IViewerFloor>[] {
		return Object.values(this);
	}

	public get length(): number {
		return this.listAsync.length;
	}
}
